module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations-large@2x.e5955864.png";